import { fetchFeaturedCrews, fetchUserMemberships } from '../../ducks/crews.duck';

export const loadData = () => (dispatch, getState) => {
  const state = getState();
  const currentUser = state.user?.currentUser;
  const userId = currentUser?.id?.uuid;

  const requests = [dispatch(fetchFeaturedCrews({ limit: 24 }))];

  if (userId) {
    requests.push(dispatch(fetchUserMemberships(userId)));
  }

  return Promise.all(requests);
};
